import { forwardRef } from 'react';
import type { View } from 'react-native';

import { Center, HStack, Text, VStack, theme } from '@squire/ui';

import { CreditCardIcon } from '@/components/_icons';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';
import { formatPrice } from '@/utils/internationalizationUtils';

import { styles } from './styles';
import type { ViewOrderDepositCardProps } from './types';

const ViewOrderDepositCard = forwardRef<View, ViewOrderDepositCardProps>(
  (
    {
      total,
      currency,
      refundable,
      testID = 'view-order-deposit-card',
      ...props
    },
    ref,
  ) => {
    const { t, i18n } = useScreenTranslations('ViewOrderDepositCard');

    return (
      <HStack ref={ref} space={theme.spacing[5]} testID={testID} {...props}>
        <Center style={styles.iconTile}>
          <CreditCardIcon color="iconBrand" size={20} />
        </Center>
        <VStack flex space={theme.spacing[1]}>
          <HStack style={styles.titleRow}>
            <Text
              variant="mStrong"
              color="cartTextPrimary"
              style={styles.title}
            >
              {t('title')}
            </Text>
            <Text variant="mStrong" color="cartTextPrimary">
              {formatPrice(total / 100, { currency, locale: i18n.language })}
            </Text>
          </HStack>
          <Text variant="m" color="cartTextSecondary">
            {refundable ? t('refundable') : t('nonRefundable')}
          </Text>
        </VStack>
      </HStack>
    );
  },
);

ViewOrderDepositCard.displayName = 'ViewOrderDepositCard';
export { ViewOrderDepositCard };
